import { PreparedQueryModel } from '@aipb/gulliver/catalog/model';
import { AuthService } from '@aipb/shared/auth';
import { UseCase } from '@aipb/shared/util/usecase';
import { inject, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PermissionUseCase implements UseCase<PreparedQueryModel, boolean> {
  private auth = inject(AuthService);

  execute(data: PreparedQueryModel) {
    if (!data.groups || data.groups.length === 0) return true;

    return this.auth.hasGroup((group: string) => {
      return data.groups.includes(group);
    });
  }
}
